
<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" width="11.585" height="8.689" viewBox="0 0 11.585 8.689" v-on="$listeners">
        <g id="Groupe_3161" data-name="Groupe 3161" transform="translate(-22 -981.361)">
            <path id="Tracé_2944" data-name="Tracé 2944" d="M33.429,985.292l-3.31-3.724a.62.62,0,1,0-.924.828l2.392,2.689H22.621a.621.621,0,0,0,0,1.241h8.966L29.2,989.016a.636.636,0,0,0,.049.882.628.628,0,0,0,.875-.055l3.31-3.724A.627.627,0,0,0,33.429,985.292Z" transform="translate(0 0)" :fill="color"/>
        </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'ArrowRight',
    mixins: [Colorable],
};
</script>
